<!-- 没有导航，低栏等样式的layouts -->
<template>
  <!-- prettier-ignore -->
  <div class=''>
    <nuxt />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
